<template>
  <div class="card col-12 mt-6">
    <div class="card-body text-center">
      <div class="row">
        <div class="col-12">
          <h2>Include a few competitors to gain a better perspective</h2>

          <p class="mb-1">
            Set up your competitors in the system to enable a detailed comparison of your company's
            performance against theirs. This will help you identify strengths and weaknesses,
            allowing for strategic adjustments to improve your market position.
          </p>

          <button class="btn btn-lg btn-primary mt-3" @click="navigateToCompetitionSettings">
            Add Competition
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CompetitionEmptyState',
  methods: {
    navigateToCompetitionSettings() {
      this.$router.push('/company-settings/competition')
    }
  }
}
</script>
